import React from "react";
import CustomTooltip from "../../../../../../common/customTooltip/CustomTooltip";
import styles from "./style.module.scss";
import { parse2Digit } from "views/pages/manage/unAssigned/otherCharges/otherChargeDetails/OtherChargeList";
import { getFormattedDate } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import {
  formattedPrice,
  paymentStatusMapping,
  paymentStatusStyle,
  PROGRAM_ACTION_LIST,
} from "../constant";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { getFormattedTime } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const JodoRows = ({
  row,
  installment,
  isParent,
  isChildren,
  childIndex,
  representHandler = () => { },
  currentApplicationDetails
}) => {
  const paymentStatus =
    row.paymentStatus != "BOUNCED"
      ? paymentStatusMapping?.[row.paymentStatus] ?? row.paymentStatus
      : row?.representEnabled && isChildren
        ? "Re-Initiated"
        : "Bounced";
  console.log('payment', paymentStatus)
  return (
    <>
      <div>{getFormattedDate(row.dueDate)}</div>
      <div>{row.referenceNumber}</div>
      <div>{row.jodoStudentId}</div>
      <div>{row.paymentMode}</div>
      <div>{row.paymentModeDate?`${getFormattedDate(row.paymentModeDate)} ${getFormattedTime(row.paymentModeDate)}`:'-'}</div>
      <div
        className={`ellipsis-text-container ${isParent ? "semi-bolder label-color" : ""
          } ${styles["amount-cell"]}`}
      >
        {formattedPrice(row.payableAmount)}
      </div>
      <div
        className={`ellipsis-text-container ${isParent ? "semi-bolder label-color" : ""
          } ${styles["amount-cell"]}`}
      >
        {formattedPrice(row.paidAmount)}
      </div>

      <div>
        <span style={paymentStatusStyle?.[paymentStatus]}>{paymentStatus}</span>
      </div>

      {childIndex == 0 && row?.paymentStatus == "BOUNCED" && (
        <div>
          <AButton
            variant="primary_filled"
            className="btn-left-0"
            size="xs"
            onClick={() => {
              representHandler(row);
            }}
            disabled={row?.representEnabled
              || !PROGRAM_ACTION_LIST.includes(currentApplicationDetails?.programActions 
              || !row?.payableAmount)
              || (new Date(currentApplicationDetails?.courseEndDate)) < (new Date()) 
            }
          >
            Represent
          </AButton>
        </div>
      )}
    </>
  );
};
export default JodoRows;
